import { TFunction } from "i18next"
import { RouteIcon } from "./route-icon"
import { StyledNavlink } from "./styled-navlink"
import { TreeNode } from "../../../@client/Theasoft_ApiServer__Utils_TreeBase"
import { IAttachmentUploadQueueItem } from "../../../attachment-api/components/attachment-upload-context"
import { AttachmentControllerRoute } from "../../../attachment-api"
import { NavTreeRoute } from "../../../@client/Theasoft_ApiServer_NavigationTree"
import { Badge } from "@mantine/core"
import { mapNodeIdToTranslation } from "./mapNodeIdToTranslation.ts"

interface Props {
  nodes: TreeNode<NavTreeRoute>[]
  t: TFunction<"app_server", undefined>
  onNodeClick?: () => void
  iconsOnly?: boolean
  uploadQueue?: IAttachmentUploadQueueItem<AttachmentControllerRoute>[]
  unreadMessageCount?: number
  currentUserId?: number
  openRemindersCount?: number
}

export function RecursiveNavLink({
  nodes,
  t,
  iconsOnly,
  uploadQueue,
  onNodeClick,
  unreadMessageCount,
  currentUserId,
  openRemindersCount,
}: Props) {
  return nodes.map((node) => {
    const hasChildren = node.children && node.children.length > 0
    let navigateOptions: any = { to: node.nodeProps.route }
    if (node.nodeProps.nodeId === "Reminders" && currentUserId) {
      navigateOptions = {
        to: node.nodeProps.route,
        search: { userId: currentUserId },
      }
    }
    return (
      <StyledNavlink
        nodeId={node.nodeProps.nodeId}
        disableLink={hasChildren}
        initiallyOpened={node.nodeProps.initiallyOpened ?? false}
        maw="100%"
        leftSection={
          <RouteIcon uploadQueue={uploadQueue} nodeId={node.nodeProps.nodeId} />
        }
        rightSection={
          node.nodeProps.nodeId === "Chat" && unreadMessageCount ? (
            <Badge circle style={{ rotate: "-90deg" }}>
              {unreadMessageCount}
            </Badge>
          ) : node.nodeProps.nodeId === "Reminders" && openRemindersCount ? (
            <Badge circle style={{ rotate: "-90deg" }}>
              {openRemindersCount}
            </Badge>
          ) : null
        }
        key={node.value}
        label={
          iconsOnly
            ? undefined
            : t(mapNodeIdToTranslation(node.nodeProps.nodeId))
        }
        navigateOptions={navigateOptions}
        styles={{
          children: {
            paddingInlineStart: iconsOnly ? 0 : undefined,
          },
          section: {
            paddingLeft: 3,
          },
        }}
        onClick={onNodeClick}
      >
        {node.children?.length
          ? RecursiveNavLink({
              nodes: node.children,
              t,
              onNodeClick,
              iconsOnly,
              unreadMessageCount,
              currentUserId,
              openRemindersCount,
            })
          : null}
      </StyledNavlink>
    )
  })
}
